import { render, staticRenderFns } from "./PlaceOrder2.vue.vue?vue&type=template&id=6e85cf0f&"
import script from "./PlaceOrder2.vue.vue?vue&type=script&lang=js&"
export * from "./PlaceOrder2.vue.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports